import Cookies from 'js-cookie'
export default {
    get(key) {
        return Cookies.get(key) ? Cookies.get(key) : null
    },

    set(key, val) {
        try {
            Cookies.set(key, val)
        } catch (e) {
            console.log(e);
        }
    },

    remove(key) {
        Cookies.remove(key)
    }
}
